import { EVENT_SOURCE } from '../../constants/analytics';

import { type CommonAttributes } from './types';

type onDropdownResultClickedArgs = {
	commonAttributes: CommonAttributes;
	socialSignal: string;
};

export const onSocialSignalClickedAnalyticsContext = ({
	commonAttributes,
	socialSignal,
}: onDropdownResultClickedArgs) => ({
	eventType: 'ui',
	source: EVENT_SOURCE,
	attributes: {
		...commonAttributes,
		isFullPageSearch: true,
		socialSignal,
	},
});
